/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  const free_gift = document.querySelectorAll('.free-gift-product');

  if (typeof(free_gift) != 'undefined' && free_gift != null) {
    free_gift.forEach((product) => {
        const variants = product.querySelectorAll('.variant-button input'),
              input_id = product.querySelector('[name="id"]'),
              add_to_cart = product.querySelector('.product__submit__add');

        variants.forEach((variant) => {
            variant.addEventListener('click', function() {
                const variant_ID = variant.getAttribute('id'),
                      available = variant.getAttribute('data-available');

                input_id.value = variant_ID;

                if(available == 'true') {
                  add_to_cart.disabled = false;
                  add_to_cart.innerHTML = window.theme.strings.upsellAddToCart;
                } else {
                  add_to_cart.disabled = true;
                  add_to_cart.innerHTML = window.theme.strings.soldOut;
                }
            });    
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    const infoWrapper = document.querySelectorAll('.product__slide .model-info-wrapper');

    infoWrapper.forEach(function(wrapper) {
      const infoButton = wrapper.querySelector('.model-info-btn');
      const closeButton = wrapper.querySelector('.js-close-info');
      const infoContent = wrapper.querySelector('.model-info-content');
      const sizeGuideButton = wrapper.querySelector('.js-model-size-guide-button');
      const sizeGuideModal = document.querySelector('.js-size-guide-modal');

      infoButton?.addEventListener('click', function() {
          infoContent?.classList.add('active');
          infoButton?.classList.add('active');
      });

      closeButton?.addEventListener('click', function() {
          infoContent?.classList.remove('active');
          infoButton?.classList.remove('active');
      });

      sizeGuideButton?.addEventListener('click', function() {
          sizeGuideModal.style.opacity = '1';
          sizeGuideModal.style.display = 'block';
      });
    });
  });

    // RF: Loyalty page section fade
    window.addEventListener('load', function() {
        const isLoyaltyPage = document.querySelector('.loyalty-page');

        if(!!isLoyaltyPage) {
            const sections = document.querySelectorAll('.loyalty-page__section, #shopify-section-footer');
            sections.forEach(section => section.classList.add('is-blurred'));

            const getActiveSection = () => {
                const screenCenter = window.scrollY + (window.innerHeight / 2);
                
                sections.forEach(section => {
                    const sectionTop = section.getBoundingClientRect().top + window.scrollY;
                    const sectionBottom = section.getBoundingClientRect().bottom + window.scrollY;

                    const active = screenCenter > sectionTop && screenCenter < sectionBottom;
                    section.classList.toggle('is-active', active);
                });
            }
            
            // RF: Get active section on scroll (debounced)
            let ticking = false;
            window.addEventListener('scroll', () => {
                if (!ticking) {
                    window.requestAnimationFrame(() => {
                        getActiveSection();
                        ticking = false;
                    });
                    ticking = true;
                }
            });

            // RF: Get active section on load
            getActiveSection();
        }
    });
})();

// Function which helps run JS in customizer and see the result instantly (without page reload/save)
const onShopifySectionLoad = (run) => {
  document.addEventListener('shopify:section:load', () => run('shopify:section:load'));
}

// Hotspots-Tooltips functionality for hotspots-tooltip.liquid
const initHotspotsTooltips = () => {
  const hotspots = document.querySelectorAll('[data-hotspot-trigger]');
  if (hotspots.length === 0) return;

  const closeHotspots = () => {
    hotspots.forEach(el => {
      el.classList.remove('hotspots-tooltips__hotspot--active');
      const content = el.querySelector('[data-hotspot-content]');
      if (content) {
        content.classList.add('hide');
      }
    });
  };

  hotspots.forEach(hotspot => {
    hotspot.addEventListener('click', (event) => {
      const isActive = hotspot.classList.contains('hotspots-tooltips__hotspot--active');
      const hotspotPopup = hotspot.querySelector('[data-hotspot-content]');

      event.stopPropagation();

      closeHotspots();

      if (!isActive) {
        hotspot.classList.add('hotspots-tooltips__hotspot--active');
        if (hotspotPopup) {
          hotspotPopup.classList.remove('hide');
        }
      }

      window.addEventListener('keydown', (evt) => {
        if (evt.key === 'Escape') {
          closeHotspots();
        }
      });

      setTimeout(() => {
        window.addEventListener('click', (evt) => {
          if (evt.target !== hotspot && !hotspot.contains(evt.target)) {
            closeHotspots();
          }
        }, { once: true });
      }, 100);
    });
  });
};
initHotspotsTooltips();

// Splide (autoscroll slide) functionality for carousel.liquid
const initCarouselSectionSliders = () => {
  const carouselSlidersTop = document.querySelectorAll('[data-carousel-slider-top]');
  const carouselSlidersBottom = document.querySelectorAll('[data-carousel-slider-bottom]');

  if (carouselSlidersTop.length) {
    carouselSlidersTop.forEach(slider => {
      const splideTopInstance = new Splide(slider, {
        type: 'loop',
        drag: 'free',
        direction: 'rtl',
        arrows: false,
        pagination: false,
        perPage: 5,
        gap: 29,
        breakpoints: {
          989: {
            perPage: 4,
            gap: 6
          },
          749: {
            perPage: 3,
          },
        },
        autoScroll: {
          speed: 0.5,
        }
      });
      
      splideTopInstance.mount(window.splide.Extensions);
    });
  }

  if (carouselSlidersBottom.length) {
    carouselSlidersBottom.forEach(slider => {
      const splideBottomInstance = new Splide(slider, {
        type: 'loop',
        drag: 'free',
        arrows: false,
        pagination: false,
        perPage: 5,
        gap: 29,
        breakpoints: {
          989: {
            perPage: 4,
            gap: 6
          },
          749: {
            perPage: 3,
          },
        },
        autoScroll: {
          speed: 0.5,
        }
      });
      
      splideBottomInstance.mount(window.splide.Extensions);
    });
  }
}
initCarouselSectionSliders();

const initSnapPage = () => {
  const snapPageElement = document.querySelector('[data-snap-page]');

  if (snapPageElement) {
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('swiper-wrapper');

    const sectionTitles = [];

    while (snapPageElement.firstChild) {
      const child = snapPageElement.firstChild;
      
      if (child.nodeType === Node.ELEMENT_NODE) {
        child.classList.add('swiper-slide');
        
        const titleElement = child.querySelector('h2');
        if (titleElement) {
          titleElement.style.textTransform = 'none';
          sectionTitles.push(titleElement.innerText);
        }
        wrapperDiv.appendChild(child);
      } else {
        wrapperDiv.appendChild(child);
      }
    }
    snapPageElement.appendChild(wrapperDiv);
    if (sectionTitles.length > 0) {
      const navigationDiv = document.createElement('div');
      navigationDiv.classList.add('snap-navigation');

      const navInner = document.createElement('div');
      navInner.setAttribute('snap-navigation-inner', '');
      navInner.classList.add('snap-navigation-inner');

      sectionTitles.forEach((title, index) => {
        const navItem = document.createElement('div');
        navItem.classList.add('snap-navigation-item');
        navItem.setAttribute('data-snap-navigation-item', index);
        const navText = document.createElement('span');
        navText.classList.add('snap-navigation-text');
        navText.innerText = title;
        navItem.appendChild(navText);
        navInner.appendChild(navItem);
      });
      navigationDiv.appendChild(navInner);
      snapPageElement.appendChild(navigationDiv);
    }
  
    const snapPage = new Swiper('[data-snap-page]', {
      direction: "vertical",
      slidesPerView: 1,
      mousewheel: {
        releaseOnEdges: true,
        thresholdDelta: 35
      },
      touchReleaseOnEdges: true,
      autoHeight: true,
      effect: 'fade',
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      fadeEffect: {
        crossFade: true
      }
    });

    const handleNoSwiping = () => {
      snapPage.slides.forEach(slide => 
        slide.classList.toggle('swiper-no-swiping', window.innerWidth > 990)
      );
    };
    
    handleNoSwiping();
    window.addEventListener('resize', handleNoSwiping);

    const snapNavigationItems = document.querySelectorAll('[data-snap-navigation-item]');
    snapNavigationItems.forEach((navItem, index) => {
      navItem.addEventListener('click', (evt) => {
        evt.preventDefault();
        snapPage.slideTo(navItem.dataset.snapNavigationItem);
      });
      index === 0 ? navItem.classList.add('snap-navigation-item--active') : null;
    })
  
    const snapNavigationInner = document.querySelector('[snap-navigation-inner]');
  
    snapPage.on('slideChange', () => {
      const activeSlide = snapPage.slides[snapPage.activeIndex];
      const hasTooltipsSection = activeSlide.querySelector('[data-hotspots-tooltips-section]');
      const hasTimelineSection = activeSlide.querySelector('[data-timeline-section]');
      const hasCtaBannersSection = activeSlide.querySelector('[data-cta-banners]');
      const isLastSlide = snapPage.activeIndex === snapPage.slides.length - 1;
  
      snapNavigationInner.classList.remove('snap-navigation-inner--tooltips', 'snap-navigation-inner--timeline');
      snapNavigationItems.forEach(navItem => navItem.dataset.snapNavigationItem == snapPage.activeIndex ? navItem.classList.add('snap-navigation-item--active') : navItem.classList.remove('snap-navigation-item--active'));

      if (hasTimelineSection || hasCtaBannersSection) {
        snapNavigationInner.classList.add('snap-navigation-inner--timeline')
        snapNavigationInner.scroll(999, 0);
      } else if (hasTooltipsSection) {
        snapNavigationInner.classList.add('snap-navigation-inner--tooltips')
      }

      if (isLastSlide) {
        setTimeout(() => {document.body.style.overflow = 'initial'}, 1000);
      }
    });

    document.body.addEventListener('wheel', (event) => {
      if (event.deltaY < 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });    
  }
}
initSnapPage();

const initTimelineSnap = () => {
  const timelineSection = document.querySelector('[data-timeline-section]');

  if (timelineSection) {
    const timelineSlider = new Swiper(timelineSection, {
      direction: "vertical",
      slidesPerView: 1,
      mousewheel: {
        thresholdDelta: 50
      },
      nested: true,
      autoHeight: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      breakpoints: {
        990: {
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping',
        }
      }
    });

    const timelineNavItems = timelineSection.querySelectorAll('[data-navigation-item]');

    timelineNavItems.forEach(navItem => {
      navItem.addEventListener('click', (evt) => {
        evt.preventDefault();
        timelineSlider.slideTo(navItem.dataset.navigationItem);
      })
    })
    const parentSlider = document.querySelector('[data-snap-page]').swiper;
    timelineSlider.on('slideChange', () => {
      timelineNavItems.forEach(navItem => navItem.dataset.navigationItem == timelineSlider.activeIndex ? navItem.classList.add('active-nav') : navItem.classList.remove('active-nav'));
      const isLastSlide = timelineSlider.activeIndex === timelineSlider.slides.length - 1;
      if (isLastSlide) {
        parentSlider.disable();
        document.body.style.overflow = 'hidden';
        setTimeout(() => {parentSlider.enable()}, 500);
      } else {
        document.body.style.overflow = 'initial';
      }
    })
  }
}
initTimelineSnap();

// To run JS in customizer and see the result instantly (without page reload/save) just add init function below
onShopifySectionLoad(() => {
  initHotspotsTooltips();
  initCarouselSectionSliders();
})

//Script moved over from removed script editor app
const cart = Shopify.checkout;
let availableGateways = Shopify.checkout.paymentGateways;

if (cart.currency !== "GBP") {
  availableGateways = availableGateways.filter(paymentGateway => 
    paymentGateway.name !== "Klarna - Flexible payments"
  );
}

Shopify.checkout.paymentGateways = availableGateways;


